import { Button } from '@mui/material';
import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { GrLocation } from 'react-icons/gr';
import { AiOutlinePhone } from 'react-icons/ai';
import Loader from '../Loader';

const ThankYouReferral = ({
  backtofirstpage, name, 
  baseURL, contactid, linkid, newContactId,templateid, 
}) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    getThankYouReferal();
  },[newContactId]);

  const getThankYouReferal = async () => {
    try {
      setLoading(true);
      // const res = await axios.get(`${baseURL}`)
      const res = await axios.get(`${baseURL}/testing/get-thank-sr/${templateid}/${newContactId}`,{
        headers: {
          'Cache-Control': 'no-cache',
          Pragma: 'no-cache',
          Expires: '0',         
        },
      });
      console.log('getThankYouReferal res', res);
      setData(res?.data?.data);
      setLoading(false);
    } catch (err) {
      console.log('getThankYouReferal err', err);
    }
  };

  if (loading) {
    return <Loader />;
  }
  return (
    <div className="qs-page">
      <div className="qs-card">
        <div className="qs-card-body flex min-h-[420px] flex-col items-center justify-center">
          <div className="flex justify-center space-y-3">
            <h2 className="text-lg font-semibold tracking-tight text-slate-900">{data?.company?.name}</h2>
            {/* {data?.full_address !== null && (
            <div className="flex items-center space-x-2">
              <span><GrLocation /></span>
              <span>
                {data?.full_address}
              </span>            
            </div>
            )}
                  
            {data?.phone !== null && (
            <div className="flex items-center space-x-2">
              <span><AiOutlinePhone /></span>
              <span>
                {data?.company?.phone_number}
              </span>            
            </div>
            )}                   */}
          </div>
          <div className="qs-fade-in mt-6 w-full space-y-5">            
            <div className="flex justify-center">
              <figure>
                {data?.template?.referral_image?.length > 0 && (
                  <image src={data?.template?.referral_image} alt="image not responding" width="230px" />
                )}
              </figure>
            </div>

            <div className="qs-title flex justify-center">{data?.heading}</div>
            <p className="qs-subtitle flex justify-center">{data?.body}</p>

            <div className="flex justify-center pt-2">                
              <Button                
                variant="contained"
                onClick={backtofirstpage}
                sx={{
                  borderRadius: '12px',
                  textTransform: 'none',
                  fontSize: '16px',
                  fontWeight: 500,
                  px: 4,
                  py: 1.25,
                  boxShadow: 'none',
                  '&:hover': { boxShadow: '0 6px 16px -6px rgba(37, 99, 235, 0.55)' },
                }}
              >
                Refer more friends
              </Button>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
};

export default ThankYouReferral;
